<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  name: "LineChart",
  props: ["data"],
  mounted() {
    // reformat in the way the lib wants
    let chartData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July','August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: "Monthly Premium Transaction",
          backgroundColor: "#0074D9",
          data: [],
          // borderColor:"white",
          fill:true
        },
        {
          label: "Monthly Claim Transaction",
          backgroundColor: "#FF4136",
          data: [],
          // borderColor:"red",
          fill:true
        }
      ],
    
    };
    for (let i = 0; i < this.data[1].length; i++) {
      chartData.datasets[0].data.push(this.data[1][i].total_num);
    }
    for (let i = 0; i < this.data[0].length; i++) {
      chartData.datasets[1].data.push(this.data[0][i].total_num);
    }
    
    
    this.renderChart(chartData, {
      responsive: true,
      maintainAspectRatio: false,
      lineTension:1,
      scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                padding: 25,
              }
            }]
          }
          
    });
  }
}
</script>